<template>
    <v-dialog v-if="selectedPlan" persistent class="!rounded-xl" max-width="380" v-model="showCheckout">
        <v-card dark
            :class="`!bg-black !shadow-sm  !backdrop-blur-sm !p-4 !rounded-xl !border-[1px] ${routeLink ? routeLink + '-border' : 'straight-border'}`">
            <div @click.prevent="$emit('closePaymentAddedDialog')">
                <div class="absolute right-3 top-3">
                    <v-icon @click.prevent="$emit('closePaymentAddedDialog')"
                        :color="routeLink ? colorAsRoute : '#a07a1d'">mdi-window-close</v-icon>
                </div>
            </div>
            <v-card-title
                :class="`${routeLink ? routeLink : 'straight'}_fortext capitalize justify-center font-Handel text-center py-2 text-xl`">
                confirm your subscription
            </v-card-title>

            <div>
                <div class="text-lg text-gray-300 font-Nunito font-semibold  m-2">Your Subscribtion</div>
                <div class="bg-gray-100 rounded-lg p-3 font-Nunito flex items-center gap-3 justify-between">
                    <v-avatar rounded min-width="36" width="36" max-width="36">
                        <Icon icon="tabler:premium-rights" class="!text-black" />
                    </v-avatar>
                    <div class="capitalize flex-grow  gap-2">
                        <div class="text-gray-800 font-semibold">Selected Plan </div>
                        <div class="text-gray-500 text-sm">{{ selectedPlan.name }} Plan</div>
                    </div>
                    <v-btn :to="{ name: 'Plan' }" class="pa-0" text min-width="10"
                        @click.prevent="$emit('closePaymentAddedDialog')">
                        <Icon icon="ci:caret-right-sm" class="!text-3xl !text-black" />
                    </v-btn>
                </div>
            </div>
            <div>
                <div class="text-lg text-gray-300 font-Nunito font-semibold  m-2">Pay with</div>
                <div class="bg-gray-100 rounded-lg p-3 font-Nunito flex items-center gap-3 justify-between">
                    <v-avatar rounded min-width="36" width="36" max-width="36">
                        <Icon icon="logos:mastercard" />
                    </v-avatar>
                    <div class="capitalize flex-grow  gap-2">
                        <div class="text-gray-800 font-semibold">{{ userData.pm_cardholder_name }}</div>
                        <div class="text-gray-500 text-sm">ending in {{ userData.pm_last_four }}</div>
                    </div>
                    <v-btn class="pa-0" text min-width="10" @click.prevent="$emit('changePaymentMethod'); ">
                        <Icon icon="ci:caret-right-sm" class="!text-3xl !text-black" />
                    </v-btn>
                </div>
            </div>
            <div class="flex font-Nunito justify-between items-center my-5 mx-2 text-lg text-gray-300">
                <div>
                    Total Amount
                </div>
                <div>
                    $ {{ selectedPlan.amount }}
                </div>
            </div>
            <v-btn :color="routeLink ? colorAsRoute : '#a07a1d'" class="!my-4  w-full" outlined :loading="payNowLoading"
                @click.prevent="subscribePackage">
                Pay now
            </v-btn>

        </v-card>
    </v-dialog>
</template>
<script>
import { Icon } from '@iconify/vue2';
import axios from 'axios';

export default {
    props: {
        showCheckout: Boolean,
        btnLoading: Boolean,

    },
    data() {
        return {
            dialog: true,
            payNowLoading: false,
        };
    },
    computed: {
        selectedPlan() {
            return this.$store.getters.getselectedPackageId
        },
        userData() {
            return this.$store.getters.StateUser.data;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
    methods: {
        async subscribePackage() {
            try {
                this.payNowLoading = true
                if (!this.$store.getters.StateUser.data.plan_name) {
                    const subscribeData = await axios.post('user/subscribe', {
                        id: this.$store.getters.getselectedPackageId.id,
                        package: this.$store.getters.getselectedPackageId.name
                    })
                    if (subscribeData.status == 200) {
                        const { data } = await axios.get('profiles')
                        this.$store.commit("setUser", data);
                        this.$router.push({ path: "/" });
                        this.$store.dispatch('getWelcomeModalHandler', true)

                        this.$toast(`Successfully Subscribed`, {
                            position: "top-left",
                            timeout: 5000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: {
                                iconClass: "mdi mdi-alert-circle-outline",
                                iconChildren: "",
                                iconTag: "i"
                            },
                            rtl: false
                        });

                    }
                }else{
                    const subscribeData = await axios.post('user/subscribe/swap', {
                        plan_id: this.$store.getters.getselectedPackageId.id,
                        plan_name: this.$store.getters.getselectedPackageId.name
                    });
                    if(subscribeData.status == 200){
                        const { data } = await axios.get('profiles')
                        this.$store.commit("setUser", data);
                        this.$router.push({ path: "/" });
                        console.log("Successfully Subscribed", subscribeData)
                        this.$toast(`${subscribeData.data.data.subscription} Plan Subscribed Successfully`, {
                            position: "top-left",
                            timeout: 500000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: {
                                iconClass: "mdi mdi-alert-circle-outline",
                                iconChildren: "",
                                iconTag: "i"
                            },
                            rtl: false
                        });
                    }
                }
            } catch (error) {
                console.log(error)
            } finally {
                this.payNowLoading = false
            }
        },
    },
    components: { Icon }
}
</script>

<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}
</style>